export default {
  text1: 'Benefits:',
  text2: 'About us',
  text3:
    'SIS Consulting is structured to provide, with high performance and commitment, information technology and business consulting services to the corporate world. We are committed to ensure that the existing challenges are met, with the highest level of satisfaction for our clients, employees and community.',
  text4:
    'Our investments in the strategic, management and multidisciplinary teams are constant, always contemplating business, technical and behavioral aspects. At each challenge, we apply solid knowledge in management, development, agile methodologies, and governance tools in favor of our clients.',
}
